import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { MpCommonActions } from "../../actions/mp-common.actions";
import { RfSignalsState } from "../../models/mp-common/rf-signals.state";

const initialState: RfSignalsState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(MpCommonActions.rfSignals.getSuccess, (state, action) => ({
		..._.omit(state, "error"),
		rfSignals: action.rfSignals
	})),
	on(MpCommonActions.rfSignals.getFail, (state, action) => ({
		...state,
		error: action.error,
		loading: action.loading
	}))
);

export function rfSignalsReducer(
	state: RfSignalsState | undefined,
	action: Action
): RfSignalsState {
	return reducer(state, action);
}
